var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "mb-2" }, [
        _c("label", [_vm._v("Тема письма")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|min:10|max:1000",
              expression: "'required|min:10|max:1000'",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localLetter.subject,
              expression: "localLetter.subject",
            },
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            disabled: "",
            name: "subject",
            "data-vv-as": "Тема письма",
            placeholder: "Ваш заказ...",
          },
          domProps: { value: _vm.localLetter.subject },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.localLetter, "subject", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.errors.has("subject")
          ? _c("small", { staticClass: "form-text text-danger" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.errors.first("subject")) + "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.letter.type === 6 && !_vm.order.extra_options.post_track
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("p", [_vm._v("отсутствует номер посылки для отслеживания")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.bodyBlocks[0]
        ? [
            _c("ckeditor", {
              attrs: { editor: _vm.editor, config: _vm.editorConfig },
              model: {
                value: _vm.bodyBlocks[0],
                callback: function ($$v) {
                  _vm.$set(_vm.bodyBlocks, 0, $$v)
                },
                expression: "bodyBlocks[0]",
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.fixedBlock
        ? _c("div", {
            staticClass: "alert alert-dark mb-0",
            domProps: { innerHTML: _vm._s(_vm.fixedBlock) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.bodyBlocks[1]
        ? [
            _c("ckeditor", {
              attrs: { editor: _vm.editor, config: _vm.editorConfig },
              model: {
                value: _vm.bodyBlocks[1],
                callback: function ($$v) {
                  _vm.$set(_vm.bodyBlocks, 1, $$v)
                },
                expression: "bodyBlocks[1]",
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }